import { render, staticRenderFns } from "./ProductEditDialog.vue?vue&type=template&id=510e6942"
import script from "./ProductEditDialog.vue?vue&type=script&lang=js"
export * from "./ProductEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports